import React, { useState } from 'react';
import { BiSolidShapes, BiTime, BiUserPlus } from 'react-icons/bi';

import { ClientInfoMenu } from './ClientInfoMenu';
import { DateTimeMenu } from './DateTimeMenu';
import VariableMenu from './VariableMenu';

export const ActionsMenu = ({ contextMenuList, onSelect }: { contextMenuList: any[]; onSelect: (context: any) => void }) => {
  const [pages, setPages] = useState('ActionMenu');

  return (
    <React.Fragment>
      {pages == 'ActionMenu' && (
        <div className="tw-w-[342px] tw-h-max tw-max-h-[281px] tw-relative tw-z-50">
          <div className="tw-w-[342px] tw-max-h-[272px] tw-py-2 tw-left-0 tw-top-[9px] tw-absolute tw-bg-white tw-rounded-md tw-shadow tw-border tw-border-gray-300 tw-flex-col tw-justify-start tw-items-start tw-gap-1 tw-inline-flex">
            <div className="tw-pt-2 tw-pb-1 tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex tw-bg-gray-100">
              <div className="tw-w-[342px] tw-h-5 tw-text-gray-500 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight tw-text-center">
                ⚡ Actions
              </div>
            </div>

            <div className="tw-self-stretch tw-max-h-[220px] tw-overflow-auto tw-px-2 tw-flex-col tw-justify-start tw-items-start tw-flex">
              <button
                id="btn-variable-menu"
                onClick={() => {
                  setPages('VariableMenu');
                }}
                className="tw-cursor-pointer tw-bg-transparent tw-border-none tw-self-stretch tw-px-4 tw-py-2.5 hover:tw-bg-gray-100 tw-rounded tw-justify-start tw-items-center tw-gap-3 tw-inline-flex"
              >
                <BiSolidShapes className="tw-w-6 tw-h-6 tw-relative" />
                <div className="tw-text-gray-700 tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal">Variables</div>
              </button>
              <button
                id="btn-function-menu"
                onClick={() => {
                  setPages('FunctionsMenu');
                }}
                className="tw-cursor-pointer tw-bg-transparent tw-border-none tw-self-stretch tw-px-4 tw-py-2.5 hover:tw-bg-gray-100 tw-rounded tw-justify-start tw-items-center tw-gap-3 tw-inline-flex"
              >
                <BiTime className="tw-w-6 tw-h-6 tw-relative" />
                <div className="tw-text-gray-700 tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal">Date Time</div>
              </button>
              <button
                id="btn-client-info-menu"
                onClick={() => {
                  setPages('ClientInfoMenu');
                }}
                className="tw-cursor-pointer tw-bg-transparent tw-border-none tw-self-stretch tw-px-4 tw-py-2.5 hover:tw-bg-gray-100 tw-rounded tw-justify-start tw-items-center tw-gap-3 tw-inline-flex"
              >
                <BiUserPlus className="tw-w-6 tw-h-6 tw-relative" />
                <div className="tw-text-gray-700 tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal">Client Info</div>
              </button>
            </div>
          </div>
        </div>
      )}
      {pages == 'VariableMenu' && (
        <>
          <VariableMenu
            contextMenuList={contextMenuList}
            back={() => {
              setPages('ActionMenu');
            }}
            onSelect={onSelect}
          />
        </>
      )}
      {pages == 'FunctionsMenu' && (
        <>
          <DateTimeMenu
            contextMenuList={[
              {
                name: 'Current Date (UTC)',
                variableName: '$:var_r_today_utc!',
              },
              {
                name: "User's Current Time",
                variableName: '$:var_r_now_client!',
              },
              {
                name: "User's Local Date and Time",
                variableName: '$:var_r_date_time_client!',
              },
              { name: 'Current Time (UTC)', variableName: '$:var_r_now_utc!' },
              {
                name: 'Current Date and Time (UTC)',
                variableName: '$:var_r_date_time_utc!',
              },
            ]}
            back={() => {
              setPages('ActionMenu');
            }}
            onSelect={onSelect}
          />
        </>
      )}
      {pages == 'ClientInfoMenu' && (
        <>
          <ClientInfoMenu
            contextMenuList={[
              {
                name: 'Is User device mobile',
                variableName: '$:var_r_user_device_is_mobile!',
              },
              {
                name: 'User default language',
                variableName: '$:var_r_user_default_language!',
              },
              {
                name: 'User device platform',
                variableName: '$:var_r_user_device_platform!',
              },
              {
                name: 'User browser name',
                variableName: '$:var_r_user_device_browser_name!',
              },
              {
                name: 'User interaction after (sec)',
                variableName: '$:var_r_user_interaction_after_sec!',
              },
            ]}
            back={() => {
              setPages('ActionMenu');
            }}
            onSelect={onSelect}
          />
        </>
      )}
    </React.Fragment>
  );
};
